import { faFlag } from '@fortawesome/free-solid-svg-icons';

import { Button } from 'apps/shared/scripts/components';

import {
  invoiceFooterClassName,
  reportButtonClassName,
  reportIconClassName,
} from './styles';

const InvoiceFooter = () => {
  return (
    <div className={invoiceFooterClassName}>
      <Button
        className={reportButtonClassName}
        iconClassName={reportIconClassName}
        faIcon={faFlag}
      >
        Report a problem
      </Button>
    </div>
  );
};

export default InvoiceFooter;
